import { Directive, DoCheck, inject, OnInit } from '@angular/core';
import { GOODIE_ROUTE, PRODUCTS_ROUTE, PROFILE_ROUTE } from '@mwe/constants';
import { AccountLogic, EnvironmentService, HelperService, NavigationLogic, NavigationStateService, ProfileService } from '@mwe/services';
import { NavbarConfig } from '@mwe/models';

@Directive()
export abstract class NavbarComponent implements OnInit, DoCheck {
  protected helperService = inject(HelperService);
  protected profileService = inject(ProfileService);
  protected accountLogic = inject(AccountLogic);
  protected navigationStateService = inject(NavigationStateService);
  protected navigationLogic = inject(NavigationLogic);

  protected environmentService = inject(EnvironmentService);
  isProductPath: boolean;
  isGoodiePath: boolean;
  isProfilePath: boolean;
  productsRoute = `/${PRODUCTS_ROUTE}`;
  profileRoute = `/${PROFILE_ROUTE}`;
  goodieRoute = `/${GOODIE_ROUTE}`;
  isLoggedIn = false;

  get config(): NavbarConfig {
    return this.navigationStateService.navbarConfig;
  }

  async ngOnInit() {
    this.setIsPaths();
    this.isLoggedIn = this.accountLogic.isLoggedIn();
  }

  ngDoCheck(): void {
    this.setIsPaths();
  }

  switchPortal(): void {
    this.navigationLogic.switchPortal();
  }

  private setIsPaths(): void {
    this.isProductPath = this.helperService.isProductPath();
    this.isGoodiePath = this.helperService.isGoodiePath();
    this.isProfilePath = this.helperService.isProfilePath();
  }
}
